// TODO Would prefer to be a global lodash mixin - need to figure out how to include with webpack
// or even better, actually have prototypes for each entity in the app and instantiate via "new"
import Immutable from 'immutable';
import _ from 'lodash';

const Factory = {
  make(count, obj) {
    return Immutable.fromJS(_.range(count).map(() => this.makeOne(obj)));
  },

  makeOne(obj) {
    // Handle JS objects and Immutable Maps
    const template = Immutable.Map.isMap(obj) ? obj : Immutable.fromJS(obj);
    return template.set('id', _.uniqueId(`${Date.now()}_`));
  },
};

export default Factory;
